import ItodoImage from "../../../elements/itodo-img";
function SectionAboutCompany1() {
    return (
        <>
            <div className="section-full  p-t40 p-b15 sx-bg-white sx-about-bx1-outer">
                <div className="container">
                    <div className="section-content">
                        <div className="sx-about-bx1-content-wrap">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 m-b40 wow fadeInLeft" data-wow-duration="1000ms">
                                    <div
                                        className="about-video-wrapper"
                                        style={{
                                            width: '100%',
                                            borderRadius: '24px',
                                            overflow: 'hidden',
                                            boxShadow: '0 30px 80px rgba(15, 23, 42, 0.15)',
                                            backgroundColor: '#000'
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: 'relative',
                                                paddingBottom: '56.25%',
                                                height: 0,
                                                aspectRatio: '16 / 9'
                                            }}
                                        >
                                            <iframe
                                                src="https://www.youtube.com/embed/D_UU95AY2s4?si=r8djBtvUZsn7Jx8y"
                                                title="Infotrace Analytics"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 wow fadeInRight" data-wow-duration="1000ms">
                                    <div className="sx-about-bx1-content p-l10 p-r10">
                                        <h2 className="sx-title" style={{ fontWeight: 700 }}>
                                            About Us: Infotrace Analytics
                                        </h2>
                                        <p className="m-t20">
                                            A proud subsidiary of the Onfon Group of Companies, InfoTrace Analytics has spent more than
                                            six years empowering Pan-African telecommunications, financial, and insurance leaders. We
                                            blend trusted partnerships with data-driven expertise to mitigate risk, uncover opportunities,
                                            and convert complex information into decisive, growth-ready insights.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Enhanced Cards Section */}
                            <div className="section-full p-t60 p-b0">
                                <div className="container">
                                    <div className="section-head text-center">
                                        <h2 className="sx-title">Our Core Values</h2>
                                        <div className="sx-separator-outer">
                                            <div className="sx-separator bg-primary"></div>
                                        </div>
                                        <p>Discover what drives us forward and shapes our commitment to excellence</p>
                                    </div>

                                    <div className="row justify-content-center">
                                        <div className="col-lg-4 col-md-6 col-sm-12 m-b30">
                                            <div className="sx-info-card h-100 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="200ms">
                                                <div className="sx-card-header">
                                                    <div className="sx-card-image">
                                                        <ItodoImage src="images/about/aboutinfotrace.jpg" alt="Philosophy" />
                                                    </div>
                                                </div>
                                                <div className="sx-card-body">
                                                    <h3 className="sx-card-title">Our Philosophy</h3>
                                                    <div className="sx-card-text">
                                                        <p>We provide tailor made insights to meet our clients' business needs & walk the business journey with you to ensure success of the solution and extend the relationship even after the job is done, to celebrate your growth.</p>
                                                    </div>
                                                </div>
                                                <div className="sx-card-overlay"></div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-12 m-b30">
                                            <div className="sx-info-card h-100 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="400ms">
                                                <div className="sx-card-header">
                                                    <div className="sx-card-image">
                                                        <ItodoImage src="images/about/infotracevision.jpg" alt="Vision" />
                                                    </div>
                                                </div>
                                                <div className="sx-card-body">
                                                    <h3 className="sx-card-title">Our Vision</h3>
                                                    <div className="sx-card-text">
                                                        <p>To pioneer a data-driven revolution, empowering industries and enterprises worldwide with actionable insights derived from advanced analytics and artificial intelligence.</p>
                                                    </div>
                                                </div>
                                                <div className="sx-card-overlay"></div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-12 m-b30">
                                            <div className="sx-info-card h-100 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="600ms">
                                                <div className="sx-card-header">
                                                    <div className="sx-card-image">
                                                        <ItodoImage src="images/about/infotracegoal.jpg" alt="Goal" />
                                                    </div>
                                                </div>
                                                <div className="sx-card-body">
                                                    <h3 className="sx-card-title">Our Goal</h3>
                                                    <div className="sx-card-text">
                                                        <p>At infotrace we aim to empower our clients with unparalleled insights, enabling them to optimize operations, drive innovation, and achieve sustainable growth.</p>
                                                    </div>
                                                </div>
                                                <div className="sx-card-overlay"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionAboutCompany1;